import React, { useEffect, useRef } from 'react';
import './TrexRunner.css';
import './offline-runner';

const SPRITE_1X = `${process.env.PUBLIC_URL || ''}/assets/trex/100-offline-sprite-v2.png`;
const SPRITE_2X = `${process.env.PUBLIC_URL || ''}/assets/trex/200-offline-sprite-v2.png`;

function loadSprite() {
    const hidpi = typeof window !== 'undefined' && window.devicePixelRatio > 1;
    const img = new Image();
    img.src = hidpi ? SPRITE_2X : SPRITE_1X;
    return img;
}

/**
 * Chrome T-Rex runner, themed to the app. Destroys listeners on unmount.
 */
export default function TrexRunner() {
    const hostRef = useRef(null);

    useEffect(() => {
        const host = hostRef.current;
        if (!host || typeof window.TrexRunner !== 'function') {
            return undefined;
        }

        const sprite = loadSprite();
        const runner = new window.TrexRunner(host, { imageSprite: sprite });

        return () => {
            if (runner && typeof runner.destroy === 'function') {
                runner.destroy();
            }
        };
    }, []);

    return (
        <div className="trex-runner" role="application" aria-label="Chrome dinosaur game">
            <div ref={hostRef} className="trex-runner-host" />
            <p className="trex-runner-hint">Press Space, tap, or click to play while you wait</p>
        </div>
    );
}
